module.exports = __webpack_public_path__ + "img/v03.456d0fe7.jpg";